import { useState, useEffect } from 'react';

/**
 * Hook personnalisé pour détecter si l'utilisateur est sur un appareil mobile
 * Utilise une combinaison de largeur d'écran et de user agent pour la détection
 */
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      // Vérification basée sur la largeur d'écran (breakpoint mobile standard)
      const screenIsMobile = window.innerWidth <= 768;
      
      // Vérification basée sur le user agent
      const userAgentIsMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      
      // Un appareil est considéré comme mobile si l'une des conditions est vraie
      setIsMobile(screenIsMobile || userAgentIsMobile);
    };

    // Vérification initiale
    checkIsMobile();

    // Écouter les changements de taille d'écran
    window.addEventListener('resize', checkIsMobile);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
};

/**
 * Hook pour obtenir les dimensions de l'écran en temps réel
 */
export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

/**
 * Hook pour détecter différents breakpoints responsives
 */
export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState('desktop');

  useEffect(() => {
    const checkBreakpoint = () => {
      const width = window.innerWidth;
      
      if (width < 480) {
        setBreakpoint('mobile');
      } else if (width < 768) {
        setBreakpoint('mobile-large');
      } else if (width < 1024) {
        setBreakpoint('tablet');
      } else if (width < 1200) {
        setBreakpoint('desktop');
      } else {
        setBreakpoint('desktop-large');
      }
    };

    checkBreakpoint();
    window.addEventListener('resize', checkBreakpoint);
    
    return () => window.removeEventListener('resize', checkBreakpoint);
  }, []);

  return breakpoint;
};
